/**
 * This is the enum to hold different process states of
 *  ContainerStatus.
 * 
 * @author Ved
 *
 */

 export enum ProcessState{

    /** The started state. */
	STARTED,

	/** The completed state. */
	COMPLETED,

	/** The canceled state. */
    CANCELED
    
 }